import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { HOTEL, IMG } from "@/data/site";

const Block = ({ title, children }) => (
  <div className="border-t border-charcoal/10 py-8">
    <h2 className="font-heading text-xl font-black text-charcoal md:text-2xl">{title}</h2>
    <div className="mt-4 space-y-3 font-body text-base leading-relaxed text-fog">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy"
        description="Privacy policy for the Super 8 by Wyndham Ottawa, Kansas website — what limited, anonymous analytics we collect and how we use it."
        path="/privacy"
        image={IMG.exterior}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Privacy", path: "/privacy" }]}
      />
      <PageHero
        kicker="Legal"
        lines={["Privacy", "Policy"]}
        sub="Straight talk about the limited, anonymous information this website collects."
        image={IMG.exterior}
        showCta={false}
      />

      <section className="mx-auto max-w-3xl px-5 py-20 md:px-10 md:py-28">
        <p className="font-body text-sm text-fog">Last updated: June 2026</p>

        <Block title="What we collect">
          <p>This website collects <strong className="text-charcoal">anonymous usage analytics only</strong> — such as which pages are viewed and when visitors tap buttons like "Book Direct," "Call," and "Directions." This helps us understand what guests are looking for and improve the site.</p>
          <p>We do <strong className="text-charcoal">not</strong> collect names, payment details, or reservation information through this site. There are no forms on this website — all bookings happen on the official Wyndham reservation system, which has its own privacy policy.</p>
        </Block>

        <Block title="Cookies & analytics tools">
          <p>We use privacy-conscious, first-party analytics and an aggregated analytics service to count page views and button clicks. Session recording is disabled. These tools may set basic cookies or identifiers to measure traffic. No sensitive personal information is gathered.</p>
        </Block>

        <Block title="How we use it">
          <p>Aggregated, anonymous data is used solely to operate and improve this website and to understand guest interest (for example, how many visitors view our indoor pool or truck-parking pages).</p>
        </Block>

        <Block title="Booking & third parties">
          <p>When you click "Book Direct," you leave this website and are taken to the official Wyndham (Super 8) reservation engine. Any information you provide there is governed by Wyndham's privacy policy, not ours.</p>
        </Block>

        <Block title="Your choices">
          <p>You can block or clear cookies in your browser settings at any time. Most browsers also offer a "Do Not Track" option.</p>
        </Block>

        <Block title="Contact us">
          <p>Questions about this policy? Call us at <a href={`tel:${HOTEL.phone}`} className="text-brand-red underline">{HOTEL.phoneDisplay}</a> or email <a href={`mailto:${HOTEL.email}`} className="text-brand-red underline">{HOTEL.email}</a>.</p>
          <p>{HOTEL.name} · {HOTEL.fullAddress}</p>
        </Block>
      </section>
    </>
  );
}
